import React from 'react';
import { Modal, Box, Typography, IconButton, Fade, Backdrop } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 650,
  maxHeight: '85vh',
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.25), 0 4px 16px rgba(0, 0, 0, 0.1)',
  p: 0,
  overflow: 'hidden',
  outline: 'none',
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
};

const headerStyle = {
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  p: 3,
  borderRadius: '16px 16px 0 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const contentStyle = {
  p: 3,
  maxHeight: 'calc(85vh - 120px)',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
  },
};

const closeButtonStyle = {
  color: 'white',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    transform: 'scale(1.1)',
  },
  transition: 'all 0.2s ease-in-out',
};

const BasicModal = ({ isOpen, onClose, content, title }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(5px)',
        }
      }}
    >
      <Fade in={isOpen} timeout={500}>
        <Box sx={style}>
          <Box sx={headerStyle}>
            <Typography
              id="modal-modal-title"
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 600,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                fontSize: { xs: '1.2rem', sm: '1.5rem' }
              }}
            >
              {title}
            </Typography>
            <IconButton
              onClick={onClose}
              aria-label="close"
              sx={closeButtonStyle}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={contentStyle}>
            <Typography
              id="modal-modal-description"
              sx={{
                whiteSpace: 'pre-wrap',
                color: '#2c3e50',
                fontSize: '1rem',
                lineHeight: 1.7,
                fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                '& p': {
                  marginBottom: '16px',
                },
                '& strong': {
                  color: '#667eea',
                  fontWeight: 600,
                },
              }}
            >
              {content || (
                <Box sx={{
                  textAlign: 'center',
                  py: 4,
                  color: '#7f8c8d',
                  fontStyle: 'italic'
                }}>
                  📄 Özgeçmiş bilgisi bulunmamaktadır.
                </Box>
              )}
            </Typography>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default BasicModal;
